import logo from "../../../../assets/images/neer_logo.svg";
import Button from "../../Input/Button";
import * as Icon from "react-bootstrap-icons";
import ModalButton from "../../Modals/ModalButton";
import Context from "../../../../context";
import { useContext } from "react";

export default function ManageAccountHeader() {
  const { contextState, setContextState } = useContext(Context);

  return (
    <div className="manage-account-header">
      <div className="manage-account-wrapper">
        <img className="logo-image" src={logo} alt="NES Logo" />
        <div className="header-buttons-container">
          <div className="header-buttons-wrapper">
            <Button
              className="btn btn--green btn--bordered"
              onClick={() => {
                setContextState({
                  ...contextState,
                  manageActivePage: "contact",
                });
              }}
              text="Contact"
              icon={<Icon.Telephone className="header-btn-icon" />}
            />
            <ModalButton
              className="btn btn--red btn--bordered"
              modal="gasLeak"
              payload={null}
              icon={<Icon.ExclamationTriangle className="header-btn-icon" />}>
              Gas Leak
            </ModalButton>
            <Button
              className="btn btn--blue btn--bordered"
              onClick={() => {
                localStorage.clear()
                window.location.reload(false);
              }}
              text="Log Out"
              icon={<Icon.BoxArrowLeft className="header-btn-icon" />}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
